import type { FC } from 'react';
import React from 'react';
import { Text } from '@oneaudi/unified-web-components';
import { FilterSection, StyledFieldset, StyledLegend } from './styles';
import type { CarlineGroup } from '../../../@types/mapped';
import { useUniversalState } from '../../context/UniversalStateContext';
import { FilterTag, Wrapper } from '../button/filterTag';

type Props = {
  carlineGroups: CarlineGroup[];
  filteredCarlines: { carlineGroupId: string }[];
  selectedCarlineGroups: string[];
  onClick: (id: string) => void;
  size: 'sm' | 'md';
};

export const CarlineTypeFilterSection: FC<Props> = ({
  carlineGroups,
  filteredCarlines,
  selectedCarlineGroups,
  onClick,
  size,
}) => {
  const { translations } = useUniversalState();

  const filteredIds = new Set(filteredCarlines.map((c) => c.carlineGroupId));
  const visibleCarlineGroups = carlineGroups;
  const fontSize = process.env.IS_LEGACY ? '2' : '3';

  return (
    <FilterSection>
      <StyledFieldset>
        <StyledLegend>
          <Text
            variant={{
              order: fontSize,
              style: 'normal',
              type: 'copy',
            }}
            tag="span"
            margin={[0, 0, 'var(--spacing-relative-2xs)', 0]}
          >
            {translations.filterModel}
          </Text>
        </StyledLegend>
        <Wrapper size={size}>
          {visibleCarlineGroups.map((group) => {
            const { id } = group.identifier;
            const isSelected = selectedCarlineGroups.includes(id);
            const isDisabled = !filteredIds.has(id);
            const labelText = translations[`carlineGroup.${id}`];
            return (
              <FilterTag
                key={id}
                id={id}
                text={labelText}
                onClickHandler={() => onClick(id)}
                selected={isSelected}
                disabled={isDisabled}
                dataTestId={`filterModelle-${id?.replace(/\s+/g, '')}`}
                size={size}
              />
            );
          })}
        </Wrapper>
      </StyledFieldset>
    </FilterSection>
  );
};
